import React from 'react';
import classNames from 'classnames';
import './index.scss';

export enum RemarkBannerType {
  CRITICAL = 'critical',
  NORMAL = 'normal',
}

export type RemarkBannerProps = {
  // 横幅类型：critical（严重告警，全文展示）/ normal（普通提示，单行省略）
  type: RemarkBannerType;
  // 展示文案
  message?: string;
  // 是否展示（最终是否渲染还会结合 message 判定）
  visible?: boolean;
  // 允许外部在不修改组件结构的情况下追加 class
  className?: string;
};

/**
 * 单条提示横幅：统一承载「文案展示策略」与「样式类型」
 *
 * @param {*} {
 *   type,
 *   message,
 *   visible,
 *   className,
 * }
 * @return {*}
 */
const RemarkBanner: React.FC<RemarkBannerProps> = (props) => {
  const { type, message, visible, className } = props;

  // 只有 visible 且 message 非空时才渲染
  const shouldShow = Boolean(visible && message);
  if (!shouldShow) return null;

  // 计算样式
  const legacyTypeClass =
    type === RemarkBannerType.CRITICAL
      ? 'critical-warning-message'
      : 'attention-warning-message';

  return (
    <div className={classNames('remark-banner', legacyTypeClass, className)}>
      <i className="issue-icon"></i>
      <span className="issue-text">{message}</span>
    </div>
  );
};

export default React.memo(RemarkBanner);
